import { ResponseError } from "@/openapi/generated/runtime";

export function isNotFoundError(error: unknown): boolean {
  return error instanceof ResponseError && error.response.status === 404;
}
